import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import isEmpty from 'lodash-es/isEmpty';

import styles from './InlineInput.module.scss';

const {
  'inline-input': inlineInputClass,
  textarea: textareaClass,
  'textarea-placeholder': textareaPlaceholderClass
} = styles;

const InlineInput = ({
  onSubmit = () => {},
  forceFocus = false,
  name = 'value',
  placeholder = '',
  submitBtnCopy = 'Post',
  initialValue = '',
  customClass
}) => {
  const textareaRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const initialValues = { [name]: initialValue };
  const validationSchema = Yup.object().shape({
    [name]: Yup.string().required()
  });

  const handleChange = ({ target: { innerText } }) => {
    const event = { target: { name, value: innerText } };
    formik.handleChange(event);
  };

  const handleSubmit = e => {
    textareaRef.current.innerText = '';
    onSubmit(e);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    validateOnMount: true,
    onSubmit: handleSubmit
  });

  const handleFocus = () => setIsFocused(true);

  const handleBlur = () => setIsFocused(false);

  // listen for input changes to textarea
  useEffect(() => {
    textareaRef.current.addEventListener('input', handleChange);
    textareaRef.current.addEventListener('focus', handleFocus);
    textareaRef.current.addEventListener('blur', handleBlur);

    return () => {
      textareaRef.current.removeEventListener('input', handleChange);
      textareaRef.current.removeEventListener('focus', handleFocus);
      textareaRef.current.removeEventListener('blur', handleBlur);
    };
  }, []);

  // focus element on mount
  useEffect(() => {
    if (forceFocus) textareaRef.current.focus();
  }, [forceFocus]);

  // prefill input if initial value is not blank
  useEffect(() => {
    if (initialValue) textareaRef.current.innerText = initialValue;
  }, [initialValue]);

  return (
    <form className={`${inlineInputClass} ${customClass}`} onSubmit={formik.handleSubmit}>
      <div role="textbox" contentEditable="true" className={textareaClass} ref={textareaRef} />
      {!formik.values[name] && !isFocused && (
        <div className={textareaPlaceholderClass}>{placeholder}</div>
      )}
      <button type="submit" disabled={!isEmpty(formik.errors)}>
        {submitBtnCopy}
      </button>
    </form>
  );
};

export default InlineInput;
